import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.

function EducationPage() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };
  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">empowering knowledge growth</h1>
            <p className="banner-description">
            Transform education with Shigjeta’s digital solutions, enhancing learning and bridging skill gaps.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>

        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Premium Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      <section className="about-section">
        {/* Section 1: What We Offer */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Comprehensive Digital Integration</strong></h2>
            <p>
              We provide end-to-end digital solutions for educational curriculums, ensuring schools, teachers, and students benefit from modernized and flexible learning environments.
            </p>
            <ul>
              <p><strong>Customized Platforms:</strong> Tailored tools for online learning.</p>
              <p><strong>Interactive Content:</strong> Engaging multimedia resources.</p>
              <p><strong>Teacher Support:</strong> Tools to simplify teaching workflows.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps4.1.png" alt="Digital Integration" />
          </div>
        </div>

        {/* Section 2: Benefits for Schools */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Empowering Schools & Educators</strong></h2>
            <p>
              Shigjeta enhances school operations with streamlined systems that foster student progress, simplify administration, and optimize resource management.
            </p>
            <ul>
              <p><strong>Improved Efficiency:</strong> Reduced workload with digital tools.</p>
              <p><strong>Real-Time Analytics:</strong> Insights into student performance.</p>
              <p><strong>Scalable Solutions:</strong> Adaptable for any school size.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps4.2.png" alt="School Benefits" />
          </div>
        </div>

        {/* Section 3: Interactive Learning */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Enhancing Student Engagement</strong></h2>
            <p>
              We revolutionize learning through interactive platforms that promote active participation and knowledge retention.
            </p>
            <ul>
              <p><strong>Dynamic Lessons:</strong> Video, quizzes, and simulations.</p>
              <p><strong>Skill-Based Learning:</strong> Practical and tailored programs.</p>
              <p><strong>Flexible Access:</strong> Learn anytime, anywhere.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps4.3.png" alt="Interactive Learning" />
          </div>
        </div>

        {/* Section 4: Success Stories */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Our Impact in Education</strong></h2>
            <p>
              Schools and educational institutions have achieved remarkable progress through our innovative digital support, improving results and modernizing curriculums.
            </p>
            <a href='/blog' className="cta-button">Read Our Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/ps4.4.png" alt="Success Stories" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default EducationPage;
